import { Col } from "reactstrap";
import { Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

const SearchNotFoundClass = ({ word }: { word: string }) => {
  return (
    <Col sm="12">
      <div>
        <div className="search-not-found text-center p-5">
          <Image className="img-100 mb-4" src={dynamicImage(`other-images/sad6.gif`)} alt="" />
          <P>{`Sorry, Not Found Any ${word}`}</P>
        </div>
      </div>
    </Col>
  );
};

export default SearchNotFoundClass;
